import React from 'react';

const Title = ({ content, children }) => {
  return <>{children}</>;
};
export default Title;
